/* eslint-disable react-hooks/exhaustive-deps */
import { useTranslation } from 'react-i18next';
import { useCallback, useEffect, useState } from 'react';
import Acceptance from './components/Acceptance';
import Category from './components/Category';
import Overview2 from './components/Overview2';
import ConsentLog from './components/ConsentLog';
import { Button, Form, Select } from 'antd';
import { ReloadOutlined } from '@ant-design/icons';
import CustomizeBannerService from '../../services/CustomizeBanner.service';
import UserService from '../../services/UserService';
import UserManagementService from '../../services/UserManagement.service';
import moment from 'moment';
import { DateTime } from 'luxon';

const { Option } = Select;

export default function Dashboard() {
    const { t, i18n } = useTranslation();
    const [form] = Form.useForm();
    const [domainList, setDomainList] = useState([]);
    const [yearList, setYearList] = useState([]);

    const [period, setPeriod] = useState('Last 7 Days');
    const [year, setYear] = useState(new Date().getFullYear().toString());

    const [acceptanceDetail, setAcceptanceDetail] = useState([]);
    const [cookieCategoryDetail, setCookieCategoryDetail] = useState([]);
    const [cookieConsentDetail, setCookieConsentDetail] = useState([]);

    const [companyValue, setCompanyValue] = useState('');

    const [dataCurrent, setDataCurrent] = useState(
        moment(new Date()).format('DD/MM/YYYY HH:mm')
    );
    const [refresh, setRefresh] = useState(false);

    let lang = i18n.language;
    // let periodList = ["Last 7 Days", "Last 30 Days", "This Month", "Last Month", "This Year"]
    // let periodList = ['Last 7 Days', 'Last 30 Days', 'This Year'];

    let periodList = [
        {
            name: t('Last 7 Days'),
            value: 'Last 7 Days',
        },
        {
            name: t('Last 30 Days'),
            value: 'Last 30 Days',
        },
        {
            name: t('Yearly'),
            value: 'Yearly',
        },
    ];

    // Role
    const role = UserService.role().toLowerCase();
    const admin = ['admin', 'auditor', 'super admin'].includes(role);

    const getCompany = async () => {
        try {
            const { data } = await CustomizeBannerService.getCompany();
            if (data?.resultData) {
                let listAll = data?.resultData;
                if (admin) {
                    setCompanyValue(data?.resultData[0]?.id);
                    await getDomainListByCompany(data?.resultData[0]?.id);
                    form.setFieldsValue({
                        companyId: listAll[0]?.id,
                        domainId: '',
                        period: 'Last 7 Days',
                    });
                } else {
                    const userId = UserService.getUi();
                    try {
                        const { data } =
                            await UserManagementService.getUserDetail(userId);
                        const item = data?.resultData;
                        if (item) {
                            const listByUser = listAll.filter(
                                (e) => e.id === item?.companyId
                            );
                            setCompanyValue(listByUser[0]?.id);
                            form.setFieldsValue({
                                companyId: listByUser[0]?.id,
                                domainId: '',
                                period: 'Last 7 Days',
                            });
                            getDomainList();
                        }
                    } catch (error) {
                        console.log(error);
                    }
                }
                // getDomainList(data?.resultData[0]?.id)
            }
        } catch (error) {
            console.log(error);
        }
    };

    const getDomainListByCompany = async (companyId) => {
        let ObjectSearch = {};
        ObjectSearch = {
            companyId: companyId,
            p: 1,
            ps: 10000,
            s: 'domainName',
            sd: 'DESC',
        };
        try {
            const { data } =
                await CustomizeBannerService.getDomainListByCompany(
                    ObjectSearch
                );
            if (data?.resultData) {
                const item = data?.resultData;
                setDomainList(item?.result);
            }
        } catch (err) {
            console.log(err);
        }
    };

    const getDomainList = async () => {
        try {
            const { data } = await CustomizeBannerService.getDomainList();
            if (data?.resultData) {
                const item = data?.resultData;
                setDomainList(item?.result);
            }
        } catch (err) {
            console.log(err);
        }
    };

    const onChangeDomain = async (value) => {
        // setDomainId(value);
        const period = form.getFieldValue('period');
        const domainId = value;
        const companyId = companyValue;
        let yearId = '';
        if (period == 'Yearly') {
            yearId = year;
        }
        getAcceptance(period, domainId, companyId, yearId);
        getCookieCategoryDetail(period, domainId, companyId, yearId);
        getCookieConsentGraph(period, domainId, companyId, yearId);
    };
    const onChangePeriod = async (value) => {
        setPeriod(value);
        const period = value;
        const domainId = form.getFieldValue('domainId');
        const companyId = companyValue;
        let yearId = '';
        form.resetFields(['yearly']);
        if (value === 'Yearly') {
            const year = generateYearList();
            setYearList(year);
            form.setFieldsValue({ yearly: year[0]?.value });
            yearId = year[0]?.value;
        }
        getAcceptance(period, domainId, companyId, yearId);
        getCookieCategoryDetail(period, domainId, companyId, yearId);
        getCookieConsentGraph(period, domainId, companyId, yearId);
        // console.log("onChangePeriod :: ",value)
    };

    const onChangeYear = async (value) => {
        setYear(value);
        const period = form.getFieldValue('period');
        const domainId = form.getFieldValue('domainId');
        const companyId = companyValue;
        const year = value;
        getAcceptance(period, domainId, companyId, year);
        getCookieCategoryDetail(period, domainId, companyId, year);
        getCookieConsentGraph(period, domainId, companyId, year);
    };

    // Loading
    const [isLoading, setIsLoading] = useState(false);
    const [isLoadingCate, setIsLoadingCate] = useState(false);
    const [isLoadingConsent, setIsLoadingConsent] = useState(false);

    const getAcceptance = async (period, domainId, companyId, yearValue) => {
        let ObjectSearch = {};
        ObjectSearch = {
            //Last 7 Days, Last 30 Days, This Month, Last Month, This Year
            period: period,
            domainId: domainId,
            companyId: companyId,
        };

        if (yearValue != '' && yearValue) {
            ObjectSearch.year = yearValue;
        }

        setIsLoading(true);
        try {
            const { data } = await CustomizeBannerService.getAcceptance(
                ObjectSearch
            );
            if (data?.resultData) {
                setAcceptanceDetail(data?.resultData);
                setIsLoading(false);
            }
        } catch (error) {
            console.log(error);
            setIsLoading(false);
        }
    };

    const getCookieCategoryDetail = async (
        period,
        domainId,
        companyId,
        yearValue
    ) => {
        let ObjectSearch = {};
        ObjectSearch = {
            //Last 7 Days, Last 30 Days, This Month, Last Month, This Year
            period: period,
            domainId: domainId,
            companyId: companyId,
        };

        if (yearValue != '' && yearValue) {
            ObjectSearch.year = yearValue;
        }

        setIsLoadingCate(true);
        try {
            const { data } = await CustomizeBannerService.getCookieCategory(
                ObjectSearch
            );
            if (data?.resultData) {
                setCookieCategoryDetail(data?.resultData);
                setIsLoadingCate(false);
            }
        } catch (error) {
            setIsLoadingCate(false);
            console.log(error);
        }
    };

    const getCookieConsentGraph = useCallback(
        async (period, domainId, companyId, yearValue) => {
            let ObjectSearch = {
                period,
                domainId,
                companyId,
                ...(yearValue && { year: yearValue }),
            };

            setIsLoadingConsent(true);
            try {
                const { data } =
                    await CustomizeBannerService.getCookieConsentGraph(
                        ObjectSearch
                    );
                if (data?.resultData) {
                    const graphResponses = data.resultData;
                    let responses = {
                        dateLabel: '',
                        graph: [],
                    };

                    if (period === 'Last 7 Days') {
                        responses.dateLabel = `${DateTime.fromISO(
                            graphResponses[0].date
                        ).toFormat('dd/MM/yyyy')} - ${DateTime.fromISO(
                            graphResponses[graphResponses.length - 1].date
                        ).toFormat('dd/MM/yyyy')}`;
                    } else if (period === 'Last 30 Days') {
                        responses.dateLabel = t('Last 30 Days');
                    } else {
                        responses.dateLabel = DateTime.now().toFormat('yyyy');
                    }

                    const formatGraphDate = (date) => {
                        return period === 'Yearly'
                            ? lang === 'en'
                                ? DateTime.fromISO(date).toFormat('MMMM')
                                : DateTime.fromISO(date, {
                                      locale: 'th',
                                  }).toFormat('MMMM')
                            : lang === 'en'
                            ? DateTime.fromISO(date).toFormat('dd MMM yyyy')
                            : DateTime.fromISO(date, { locale: 'th' }).toFormat(
                                  'dd MMM yyyy'
                              );
                    };

                    const cookieConsent = graphResponses.map((graph) => ({
                        date: formatGraphDate(graph.date),
                        value: graph?.cookieConsent,
                        type: t('COOKIE.CookieConsent'),
                    }));

                    const acceptAll = graphResponses.map((graph) => ({
                        date: formatGraphDate(graph.date),
                        value: graph?.acceptAll,
                        type: t('COOKIE.AcceptAll'),
                    }));

                    responses.graph = [...cookieConsent, ...acceptAll];
                    setCookieConsentDetail(responses);
                }
            } catch (error) {
                console.log(error);
            } finally {
                setIsLoadingConsent(false);
            }
        },
        [lang, t]
    );

    const getAllService = useCallback(async () => {
        await getCompany();
        setDataCurrent(moment(new Date()).format('DD/MM/YYYY HH:mm'));
        setRefresh(true);
        const period = form.getFieldValue('period');
        const domainId = form.getFieldValue('domainId');
        const companyId = form.getFieldValue('companyId');
        getAcceptance(period, domainId, companyId);
        getCookieCategoryDetail(period, domainId, companyId);
        getCookieConsentGraph(period, domainId, companyId);
    }, [form]);

    useEffect(() => {
        getAllService();
    }, []);

    useEffect(() => {
        const period = form.getFieldValue('period');
        const domainId = form.getFieldValue('domainId');
        const companyId = form.getFieldValue('companyId');
        if (companyId && period) {
            getAcceptance(period, domainId, companyId);
            getCookieCategoryDetail(period, domainId, companyId);
            getCookieConsentGraph(period, domainId, companyId);
        }
    }, [lang]);

    const generateYearList = () => {
        const currentYear = new Date().getFullYear();
        const yearList = [];
        for (let i = 0; i <= 5; i++) {
            yearList.push({ value: currentYear - i, name: currentYear - i });
        }
        return yearList;
    };

    return (
        <div>
            <div className="title ">{t('COOKIE.CookieConsentDashboard')}</div>
            <div className="sub-title">
                <span className="text-sm text-gray-400">
                    {' '}
                    {t('COOKIE.CookieManagement')} /{' '}
                </span>
                <span> {t('COOKIE.CookieConsentDashboard')}</span>
            </div>

            <Form form={form} layout="vertical">
                <div className="flex items-center justify-end space-x-3 ">
                    <div className="text-[#65707A]">
                        {t('Last Update')} : {dataCurrent}
                    </div>
                    <Button
                        onClick={async () => {
                            getAllService();
                        }}
                        size="large"
                        type="primary"
                        className="px-6 bg-[#65707A] border-[#65707A] hover:bg-[#747E87] hover:border-[#747E87]"
                        icon={<ReloadOutlined />}
                    >
                        {t('Refresh')}
                    </Button>
                </div>

                <div className="grid grid-cols-12 my-4 p-6 bg-white rounded-md flex items-center ">
                    <div
                        className={
                            period === 'Yearly' ? 'col-span-5' : 'col-span-6'
                        }
                    >
                        <span className="text-xl text-purple">
                            {t('COOKIE.CookieDashboard')}
                        </span>
                    </div>

                    <div className="col-span-3">
                        <Form.Item name="domainId" className="w-full mb-0">
                            <Select
                                placeholder={t('COOKIE.PleaseSelectDomain')}
                                size="large"
                                // clearIcon={true}
                                onChange={onChangeDomain}
                                defaultValue=""
                                // allowClear
                                showSearch
                                optionFilterProp="children"
                                filterOption={(input, option) =>
                                    (option?.children ?? '')
                                        .toLowerCase()
                                        .includes(input.toLowerCase())
                                }
                            >
                                <Option key={'All Domain'} value={''}>
                                    {t('MyTask.AllDomain')}
                                </Option>
                                {domainList?.map((e) => (
                                    <Option
                                        key={e?.domainId}
                                        value={e?.domainId}
                                    >
                                        {e.domainName}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </div>
                    {period === 'Yearly' && (
                        <div className="col-span-2 ml-4">
                            <Form.Item name="yearly" className="w-full mb-0">
                                <Select
                                    defaultValue={yearList[0]?.value}
                                    size="large"
                                    onChange={onChangeYear}
                                >
                                    {yearList?.map((e, i) => (
                                        <Option key={i} value={e.value}>
                                            {e.name}
                                        </Option>
                                    ))}
                                </Select>
                            </Form.Item>
                        </div>
                    )}
                    <div
                        className={
                            period === 'Yearly'
                                ? 'col-span-2 ml-4'
                                : 'col-span-3 ml-4'
                        }
                    >
                        <Form.Item name="period" className="w-full mb-0">
                            <Select
                                placeholder={t('COOKIE.PleaseSelectPeriod')}
                                defaultValue={periodList[0]?.value}
                                size="large"
                                onChange={onChangePeriod}
                            >
                                {periodList?.map((e, i) => (
                                    <Option key={i} value={e.value}>
                                        {e.name}
                                    </Option>
                                ))}
                            </Select>
                        </Form.Item>
                    </div>
                </div>
                <div className="grid grid-cols-12 mt-4">
                    <div className="col-span-3 bg-white rounded-md mr-2 p-6">
                        <Acceptance
                            isLoading={isLoading}
                            acceptanceDetail={acceptanceDetail}
                        />
                    </div>
                    <div className="col-span-3 bg-white rounded-md mr-2 ml-2 p-6">
                        <Category
                            isLoadingCate={isLoadingCate}
                            cookieCategoryDetail={cookieCategoryDetail}
                        />
                    </div>
                    <div className="col-span-6 bg-white rounded-md ml-2 p-6">
                        <Overview2
                            isLoadingConsent={isLoadingConsent}
                            cookieConsentDetail={cookieConsentDetail}
                        />
                    </div>
                </div>
                <div className="grid grid-cols-12 my-6 p-6 bg-white rounded-md">
                    <ConsentLog
                        form={form}
                        companyId={companyValue}
                        domainId={form.getFieldsValue()?.domainId}
                        period={form.getFieldsValue()?.period}
                        yearList={yearList}
                        setRefresh={setRefresh}
                        refresh={refresh}
                        year={year}
                    />
                </div>
            </Form>
        </div>
    );
}
